import { render, staticRenderFns } from "./Helpdesk.vue?vue&type=template&id=5dae0aaa&scoped=true"
import script from "./Helpdesk.vue?vue&type=script&lang=js"
export * from "./Helpdesk.vue?vue&type=script&lang=js"
import style0 from "./Helpdesk.vue?vue&type=style&index=0&id=5dae0aaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dae0aaa",
  null
  
)

export default component.exports